export default __webpack_public_path__ + "static/media/tete1.0e33aab6.png";